module.exports = __webpack_public_path__ + "img/icon_credit.e6889dbd.png";